import { ReactNode } from "react";
import { makeStyles } from "tss-react/mui";
import { IconButton, IconButtonProps } from "@mui/material";

export interface MiIconButtonProps extends Omit<IconButtonProps, "color"> {
  children: ReactNode;
  disableRipple?: boolean;
  disableFocusRipple?: boolean;
  disabled?: boolean;
  className?: string;
  dataTestId?: string;
  "data-testid"?: string;
  color?: IconButtonProps["color"];
}

export const MiIconButton = ({
  disableRipple = true,
  disableFocusRipple = true,
  children,
  disabled = false,
  onClick,
  className,
  dataTestId = "mi-icon-button",
  color,
  ...rest
}: MiIconButtonProps) => {
  const { classes, cx } = useStyles();

  return (
    <IconButton
      disableFocusRipple={disableFocusRipple}
      disableRipple={disableRipple}
      color={color}
      disabled={disabled}
      onClick={onClick}
      className={cx(classes.iconButton, className)}
      data-testid={rest["data-testid"] || dataTestId}
      {...rest}
    >
      {children}
    </IconButton>
  );
};

const useStyles = makeStyles()(() => ({
  iconButton: {
    "&:hover": {
      backgroundColor: "transparent",
    },
    "&:focus": {
      outline: 0,
    },
    "&:active": {
      outline: "none",
    },
    "&:disabled": {
      backgroundColor: "transparent",
      opacity: 0.5,
    },
  },
}));
